export function getDeviceId() {
  let id = localStorage.getItem("pitso_device");
  if (!id) {
    id = "dev_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("pitso_device", id);
  }
  return id;
}
